import {
  BaseLayoutSchema,
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
  ExpressionReferenceInput,
  IWidgetComponentProps,
  LayoutHideConfigInput,
  ReferenceSchema,
  WidgetRepository,
  isSameFieldDatatype,
  useTreeReferencesContext,
} from '@framework/engine';
import { FormItem } from '@framework/form';
import { RowElement } from '@framework/ui';
import { yup } from '@framework/validation';
import React, { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { ICompetenceWidget, WidgetTypeCompetence } from './ICompetenceWidget';

export const CompetenceWidgetConfigSchema: yup.ObjectSchema<ICompetenceWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetTypeCompetence).required(),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
    }),
    sourceValueReference: ReferenceSchema.notRequired()
      .label('Assegna automaticamente')
      .when('layout.hide', ([hide]: boolean[], schema) => {
        return hide ? schema : schema.strip();
      }),
  })
    .required()
    .noUnknown();

export interface ICompetenceInputConfigComponentProps
  extends IWidgetComponentProps<ICompetenceWidget> {}

export function CompetenceInputConfigComponent(
  props: ICompetenceInputConfigComponentProps,
) {
  const isHidden = useWatch({ name: 'layout.hide', exact: true });
  const { references, widget } = useTreeReferencesContext();
  const fieldDataType = useMemo(
    () =>
      WidgetRepository.find(widget?.type)?.getReference?.([], widget!)?.field,
    [widget],
  );
  const expressionReferences = useMemo(() => {
    if (!isHidden) return [];
    return references.filter(
      r =>
        // Deve avere lo stesso fieldDataType e non essere il campo stesso
        isSameFieldDatatype(r.field, fieldDataType) && r.id !== widget?.id,
    );
  }, [isHidden, references, fieldDataType, widget?.id]);

  return (
    <div>
      <CommonConfigComponent {...props} />
      <LayoutHideConfigInput />
      {/* Se il campo competenza è nascosto posso richiedere che il suo valore si riferisca a un altro campo */}
      {isHidden && (
        <RowElement>
          <FormItem
            name="sourceValueReference"
            label="Assegna automaticamente"
            help="Se il campo viene nascosto, è possibile impostare il suo valore a quello di un altro campo indicato."
          >
            <ExpressionReferenceInput
              size="large"
              key="reference"
              name="sourceValueReference"
              width="100%"
              references={expressionReferences}
            />
          </FormItem>
        </RowElement>
      )}
    </div>
  );
}
